class MytrexHeroSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.mtrx-hero__track');
    this.slides = Array.from(el.querySelectorAll('.mtrx-hero__slide'));
    this.dots = Array.from(el.querySelectorAll('.mtrx-hero__dot'));
    this.prevBtn = el.querySelector('.mtrx-hero__arrow--prev');
    this.nextBtn = el.querySelector('.mtrx-hero__arrow--next');
    this.count = this.slides.length;
    this.current = 0;
    this.autoplayMs = parseInt(el.dataset.autoplay, 10) || 0;
    this.timer = null;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.isDragging = false;

    this.fitMobile = this.el.classList.contains('mtrx-hero--fit-mobile');

    if (this.count < 2) return;
    this._bind();
    if (this.fitMobile) this._initAutoHeight();
    if (this.autoplayMs) this._startAutoplay();
  }

  go(index) {
    this.current = ((index % this.count) + this.count) % this.count;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
    this.dots[this.current]?.setAttribute('aria-current', 'true');
    this.dots.forEach((d, i) => { if (i !== this.current) d.removeAttribute('aria-current'); });
    if (this.fitMobile) this._updateHeight();
    if (this.autoplayMs) { this._stopAutoplay(); this._startAutoplay(); }
  }

  _initAutoHeight() {
    this.mq = window.matchMedia('(max-width: 767px)');
    const update = () => this._updateHeight();
    // images may not be loaded yet — remeasure on load
    this.slides.forEach((s) => {
      const img = s.querySelector('.mtrx-hero__img');
      if (img && !img.complete) img.addEventListener('load', update, { once: true });
    });
    window.addEventListener('resize', update);
    this.mq.addEventListener('change', update);
    this._updateHeight();
  }

  _updateHeight() {
    if (!this.fitMobile) return;
    if (this.mq.matches) {
      const img = this.slides[this.current].querySelector('.mtrx-hero__img');
      const h = img ? img.offsetHeight : 0;
      if (h) this.track.style.height = `${h}px`;
    } else {
      this.track.style.height = '';
    }
  }

  _bind() {
    this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

    this.el.addEventListener('touchstart', (e) => {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.isDragging = false;
    }, { passive: true });

    this.el.addEventListener('touchmove', (e) => {
      const dx = Math.abs(e.touches[0].clientX - this.touchStartX);
      const dy = Math.abs(e.touches[0].clientY - this.touchStartY);
      if (dx > dy) this.isDragging = true;
    }, { passive: true });

    this.el.addEventListener('touchend', (e) => {
      if (!this.isDragging) return;
      const dx = e.changedTouches[0].clientX - this.touchStartX;
      if (Math.abs(dx) > 40) this.go(dx < 0 ? this.current + 1 : this.current - 1);
    });

    this.el.addEventListener('mouseenter', () => this._stopAutoplay());
    this.el.addEventListener('mouseleave', () => { if (this.autoplayMs) this._startAutoplay(); });

    this.el.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.go(this.current - 1);
      if (e.key === 'ArrowRight') this.go(this.current + 1);
    });
  }

  _startAutoplay() {
    this.timer = setInterval(() => this.go(this.current + 1), this.autoplayMs);
  }

  _stopAutoplay() {
    clearInterval(this.timer);
  }
}

document.querySelectorAll('.mtrx-hero').forEach((el) => new MytrexHeroSlider(el));
